{
  "__localization_test_string": "آپ {{time_period}}کے لیے اس فراہم کنندہ کے دوروں کی زیادہ سے زیادہ تعداد تک پہنچ گئے ہیں۔ آپ اگلی بار {{start_date}}سے شروع ہونے والے اس فراہم کنندہ پر جا سکتے ہیں۔",
  "app_name": "Plentiful",
  "app_button_ok": "ٹھیک ہے",
  "app_button_cancel": "منسوخ کریں۔",
  "app_button_yes": "جی ہاں",
  "app_button_no": "نہیں",
  "app_button_confirm": "تصدیق کریں۔",
  "app_button_try_again": "دوبارہ کوشش کریں",
  "rate_the_app": "Plentiful کو ریٹ کریں",
  "app_textview_somethingwentwrong": "کچھ غلط ہو گیا!\nبراہ کرم دوبارہ کوشش کریں۔",
  "app_button_logout": "لاگ آوٹ",
  "app_today": "آج",
  "app_dialog_clarify_prompt": "کیا تمہیں یقین ہے؟",
  "app_personal_edittext_phone": "فون نمبر",
  "app_personal_edittext_dob": "تاریخ پیدائش (اختیاری)",
  "app_personal_edittext_firstname": "پہلا نام",
  "app_personal_edittext_lastname": "آخری نام",
  "app_personal_edittext_zipcode": "زپ کوڈ",
  "app_pantrykind_food": "فوڈ پینٹری",
  "app_servicekind_reservations": "تحفظات",
  "app_servicekind_line": "لائن",
  "distribution_schedule": "تقسیم کا شیڈول",
  "service_type_no_digital_options": "صرف لائن",
  "service_type_reservation_inline": "ریزرویشن",
  "service_type_allows_pre_registration": "پیشگی رجسٹریشن کی اجازت",
  "app_locationnotavailable": "مقام دستیاب نہیں ہے۔",
  "app_generalerror": "خرابی",
  "app_dialog_loading": "لوڈ ہو رہا ہے۔ براہ کرم…انتظار کریں۔",
  "app_dialog_sms_code_title": "ایس ایم ایس کوڈ",
  "app_dialog_sms_code_button_send_new_code": "ایک نیا کوڈ بھیجیں۔",
  "app_release_id": "ایپلیکیشن ریلیز شناخت کنندہ",
  "sms_disclaimer": "پیغام اور ڈیٹا کی فیس لاگو ہو سکتی ہے۔ رکنے کے لیے STOP بھیجیں۔",
  "fragment_registration_language_textview_title": "شروع کرنے کے لیے اپنی پسند کی زبان منتخب کریں۔",
  "fragment_registration_language_button_next": "اگلے",
  "fragment_registration_family_textview_title": "ہمیں اپنے گھر والوں کے بارے میں بتائیں",
  "fragment_registration_family_textview_adults": "({{senior_age_threshold_minus_one}}-18) بالغوں کی تعداد",
  "fragment_registration_family_textview_children": "بچوں کی تعداد (18 سال سے کم)",
  "fragment_registration_family_textview_seniors": "(+{{senior_age_threshold}}) بزرگوں کی تعداد",
  "fragment_registration_family_textview_notetitle": "نوٹ:",
  "fragment_registration_family_textview_notecontent": "اپنے گھر کے بارے میں تفصیلات فراہم کرکے آپ کی بہتر خدمت کرنے میں ہماری مدد کریں۔ براہ کرم نوٹ کریں: اپنے آپ کو ان گھریلو اراکین کی تعداد میں شامل نہ کریں جن کی آپ اوپر فہرست کرتے ہیں۔",
  "fragment_registration_family_button_back": "پیچھے",
  "fragment_registration_family_button_next": "اگلے",
  "fragment_registration_personal_textview_title": "آپ کے Plentiful پروفائل میں خوش آمدید",
  "fragment_registration_personal_button_back": "پیچھے",
  "fragment_registration_personal_button_finish": "ختم",
  "fragment_main_tabitem_pantrymap": "نقشہ",
  "fragment_main_tabitem_pantrylist": "فہرست",
  "fragment_main_bottombar_pantries": "پینٹریز",
  "fragment_main_bottombar_visits": "دورے",
  "fragment_main_bottombar_messages": "پیغامات",
  "fragment_main_bottombar_profile": "پروفائل",
  "cell_pantry_short_visit_date": "تم جا رہے ہو",
  "fragment_pantrydetail_button_changetime": "وقت کو تبدیل کریں۔",
  "fragment_pantrydetail_textview_amenities": "سہولیات",
  "fragment_pantrydetail_textview_conditions": "شرائط",
  "fragment_pantrydetail_textview_notes": "پینٹری نوٹ",
  "fragment_pantrydetail_edittext_message": "پیغام…",
  "fragment_pantrydetail_button_createreservation": "وزٹ کا شیڈول بنائیں",
  "fragment_pantrydetail_button_schedulevisit": "وزٹ کا شیڈول بنائیں",
  "dialog_visittime_textview_nodatesavailable": "کوئی تاریخیں دستیاب نہیں ہیں۔",
  "fragment_visitlist_textview_title": "دورے",
  "fragment_visitlist_textview_zero": "یہ وہ جگہ ہے جہاں آپ اپنے آنے والے سروس کے اوقات کا نظم کر سکتے ہیں۔ وزٹ شیڈول کرنے کے لیے پینٹری تلاش کریں!",
  "fragment_messagethreadlist_textview_title": "پیغامات",
  "fragment_messagethreadlist_textview_zero": "ابھی تک کوئی اپ ڈیٹ نہیں!\nاپ ڈیٹس کو سبسکرائب کرنے کے لیے، اپنی پسندیدہ پینٹری کے تفصیلات والے صفحہ پر جائیں اور صفحہ کے نیچے موجود 'اس پینٹری سے اپ ڈیٹس حاصل کریں' کو ٹوگل کریں۔",
  "fragment_profile_textview_title": "پروفائل",
  "fragment_profile_button_savechanges": "تبدیلیاں محفوظ کرو",
  "fragment_profile_textview_personaldetails": "ذاتی معلومات",
  "fragment_profile_textview_language": "زبان",
  "fragment_profile_textview_notifications": "اطلاعات",
  "fragment_profile_switch_receivenotifications": "پش نوٹیفیکیشنز",
  "receive_notifications_helper": "اپنے آلے پر الرٹس حاصل کریں",
  "fragment_profile_textview_servicedetails": "سروس کی تفصیلات",
  "fragment_profile_switch_pickupfood": "میرے پاس کسی اور نے اپنا کھانا اٹھانا ہے۔",
  "fragment_profile_edittext_pickupname": "پک اپ نمائندہ پہلا اور آخری نام",
  "fragment_profile_edittext_pickupphone": "پک اپ نمائندہ فون نمبر",
  "textview_baby_supplies": "آپ کو کتنے بچوں کے لیے بچوں کے سامان کی ضرورت ہے (ڈائیپر، وائپس، فارمولا)",
  "fragment_profile_textview_emergencycontact": "ہنگامی رابطے",
  "fragment_profile_edittext_emergencyname": "ہنگامی رابطہ پہلا اور آخری نام",
  "fragment_profile_edittext_emergencyphone": "ہنگامی رابطہ فون",
  "aiq_validation_error_regex_telephone_us": "فون نمبر غلط فارمیٹ کا ہے۔",
  "fragment_profile_textview_changepersonalinfo": "یہ معلومات کسی بھی Plentiful Food Pantry میں اپ ڈیٹ کی جا سکتی ہیں۔",
  "fragment_profile_edittext_feedback": "تاثرات…",
  "fragment_profile_toast_feedbacksent": "تاثرات بھیجے گئے۔",
  "baby_supplies": "بچے کی فراہمی",
  "household_size": "گھریلو ناپ",
  "food_pickup": "فوڈ پک اپ",
  "emergency_contact": "ہنگامی رابطے",
  "dialog_app_update_title": "اپ ڈیٹ دستیاب ہے۔",
  "dialog_app_update_message": "ایپ کا اگلا ورژن گوگل پلے اسٹور پر دستیاب ہے!",
  "dialog_app_update_button_openplaystore": "پلے اسٹور کھولیں۔",
  "app_invalid_error": "غلط",
  "no_pantries_available": "کوئی نتیجہ نہیں ملا۔ اپنی تلاش کو مختلف پینٹری کے نام کے ساتھ آزمائیں یا تلاش کے خانے کو صاف کریں اور Plentiful پینٹریز والے علاقوں کو دریافت کرنے کے لیے نقشے پر حرکت یا زوم آؤٹ کریں۔",
  "visit_served": "خدمت کی",
  "visit_not_served": "پیش نہیں کیا",
  "visit_no_show": "تم نے ظاہر نہیں کیا",
  "visit_group": "آپ گروپ میں ہیں {{group_number}}، {{time}}تک آئیں",
  "visit_pre_registered": "آپ پہلے سے رجسٹرڈ ہیں، {{from_time}} - {{end_time}}کے درمیان لائن میں شامل ہوں",
  "pick_visit_time": "وزٹ کا وقت منتخب کریں۔",
  "received_service_on": "آپ تشریف لائے",
  "service_starts_at": "سروس شروع ہوتی ہے۔",
  "cancel_visit": "دورہ منسوخ کریں۔",
  "confirm_cancel_visit": "کیا آپ واقعی اپنا دورہ منسوخ کرنا چاہتے ہیں؟",
  "yes_cancel": "ہاں، منسوخ کریں۔",
  "send": "بھیجیں",
  "reservations_available": "اس پینٹری سے اپڈیٹس حاصل کریں۔",
  "report_location_issue": "اس مقام کے ساتھ کسی مسئلہ کی اطلاع دیں۔",
  "feeding_america_network_member": "Feeding America نیٹ ورک کا حصہ",
  "feeding_america_find_food_link": "فوڈ بینک کی ویب سائٹ ملاحظہ کریں",
  "registration_intro": "Plentiful میں خوش آمدید! ہم یہاں آپ کے قریب کھانے کی پینٹری تلاش کرنے میں آپ کی مدد کرنے کے لیے موجود ہیں۔",
  "app_personal_edittext_enter_phone": "اپنا فون نمبر درج کریں۔",
  "code_sent_to": "پر ایک SMS لاگ ان کوڈ بھیجا گیا تھا۔",
  "account_created": "اکاؤنٹ بنایا گیا۔",
  "get_started": "آئیے شروع کریں!",
  "additional_details": "اضافی معلومات",
  "your_qr_code": "آپ کا پلینٹی پاس",
  "id_number": "شناختی نمبر",
  "personal_details_extra": "ذاتی معلومات اور ترجیحات",
  "settings": "ترتیبات",
  "settings_extra": "زبان اور اطلاع کی ترتیبات",
  "not_verified": "ابھی تصدیق نہیں ہوئی۔",
  "must_be_reverified_by": "کی طرف سے دوبارہ تصدیق کرنا ضروری ہے",
  "last_verified_on": "آخری بار تصدیق شدہ",
  "at": "پر",
  "no_visit_options_available": "اس وقت آپ کے لیے وزٹ کے کوئی اختیارات دستیاب نہیں ہیں۔ براہ کرم پینٹری کے حالات کو چیک کریں یا پینٹری سے رابطہ کریں۔",
  "need_help": "مدد چاہیے؟",
  "email": "ای میل",
  "terms_conditions": "اختتامی صارف کا معاہدہ",
  "privacy_policy": "رازداری کی پالیسی",
  "updates": "تازہ ترین",
  "family_details": "گھریلو تفصیلات",
  "welcome_to_plentiful": "Plentiful میں خوش آمدید!",
  "enter_email_phone": "سائن اپ کرنے سے آپ ریزرویشن کر سکتے ہیں اور کھانے کی پینٹریز کے لیے اپ ڈیٹس حاصل کرتے ہیں جو آپ دیکھتے ہیں۔\nاگر آپ کھانے کی پینٹری میں رجسٹرڈ ہیں تو وہی فون نمبر یا ای میل استعمال کریں۔ \nمدد کی ضرورت ہے؟ support@plentiful.org پر ہم سے رابطہ کریں۔",
  "email_or_phone": "موبائل نمبر یا ای میل ایڈریس",
  "email_address": "ای میل اڈریس",
  "enter_email": "اپنا ای میل درج کریں۔",
  "address": "پتہ",
  "email_invalid": "ای میل ایڈریس درست نہیں ہے۔",
  "no_sms_enabled_phone": "فون نمبر ٹیکسٹ پیغامات وصول نہیں کر سکتا",
  "verification_email_sent": "توثیقی ای میل بھیج دیا گیا!",
  "check_verification_email": "اپنا ای میل چیک کریں اور اپنے اکاؤنٹ کی تصدیق کے لیے اندر موجود بٹن پر کلک کریں۔",
  "email_verification_sent": "ہم نے آپ کو ایک ای میل بھیجی ہے۔ اپنے ای میل ایڈریس کی تصدیق کے لیے براہ کرم ای میل میں بٹن پر کلک کریں۔",
  "email_address_purpose": "Plentiful سے وزٹ ریمائنڈرز اور اہم اپ ڈیٹس حاصل کرنے کے لیے",
  "sign_up": "سائن اپ",
  "sign_in": "سائن ان",
  "continue": "جاری رہے",
  "create_password": "پاسورڈ بنائیں",
  "enter_password": "براہ کرم سائن ان کرنے کے لیے اپنا پاس ورڈ درج کریں۔",
  "password_info_box": "اگر آپ اپنا پاس ورڈ بھول گئے ہیں یا آپ پاس ورڈ سیٹ کیے بغیر کسی پینٹری میں رجسٹرڈ ہیں، تو براہ کرم جادو کے ساتھ لاگ ان کرنے یا اپنا پاس ورڈ دوبارہ ترتیب دینے کے لیے نیچے دیے گئے اختیارات کا استعمال کریں۔",
  "reset_password": "پاس ورڈ ری سیٹ",
  "password": "پاس ورڈ",
  "eight_characters": "کم از کم 8 حروف",
  "one_special_character": "کم از کم 1 خصوصی کردار",
  "one_number": "کم از کم ایک نمبر",
  "submit": "جمع کرائیں",
  "send_magic_link": "میجک لنک بھیجیں۔",
  "magic_link_sent": "ایک جادوئی لنک آپ کے ان باکس میں جا رہا ہے۔",
  "confirm_magic_link_login": "میجک لنک لاگ ان کی تصدیق کریں۔",
  "sign_in_another_way": "دوسرے طریقے سے سائن ان کریں۔",
  "enter_phone": "براہ کرم اپنا فون نمبر درج کریں۔",
  "skip": "چھوڑ دو",
  "optional": "اختیاری",
  "enter_activation_code": "براہ کرم اپنا لاگ ان کوڈ درج کریں۔",
  "activation_code": "لاگ ان کوڈ",
  "accept_eula": "میں نے استعمال کی شرائط اور رازداری کو پڑھ لیا ہے اور ان سے اتفاق کرتا ہوں۔",
  "email_verified": "ای میل کی تصدیق ہو گئی۔",
  "email_verified_details": "آپ کا ای میل پتہ اب تصدیق شدہ ہے۔",
  "do_not_ask_again": "دوبارہ مت پوچھنا۔",
  "email_in_use": "ہمارے پاس پہلے سے ہی اس ای میل سے وابستہ ایک اکاؤنٹ ہے۔ براہ کرم ایک مختلف ای میل استعمال کریں۔",
  "reset_password_text": "اپنا پاس ورڈ دوبارہ ترتیب دینے کے لیے براہ کرم اپنا ای میل درج کریں۔",
  "reset_password_sent": "پاس ورڈ دوبارہ ترتیب دیں ای میل بھیج دیا گیا!",
  "reset_password_sent_text": "اگر ہمارے پاس فائل پر {{email}}کا اکاؤنٹ ہے، تو ہم نے آپ کا پاس ورڈ دوبارہ ترتیب دینے کے لیے ایک لنک بھیجا ہے،",
  "dob_required": "پیدائش کی تاریخ",
  "please_verify": "براہ کرم اپنے پروفائل میں فون یا ای میل کی تصدیق کریں۔",
  "open_profile": "پروفائل کھولیں۔",
  "send_another_verification_email": "ایک اور تصدیقی ای میل بھیجیں۔",
  "need_to_change_email": "اگر آپ کو اپنا ای میل پتہ تبدیل کرنے کی ضرورت ہے تو، براہ کرم support@plentifulapp.com سے رابطہ کریں۔",
  "need_to_change_email_or_phone": "اگر آپ کو اپنا ای میل پتہ یا فون نمبر تبدیل کرنے کی ضرورت ہے تو، براہ کرم support@plentifulapp.com پر رابطہ کریں۔",
  "need_to_change_phone": "اگر آپ کو اپنا فون نمبر تبدیل کرنے کی ضرورت ہے تو، براہ کرم support@plentifulapp.com پر رابطہ کریں یا پینٹری دیکھیں۔",
  "email_subscription": "ای میل سبسکرپشن",
  "email_subscribed": "ای میل سبسکرائب ہو گیا۔",
  "email_unsubscribed": "ای میل ان سبسکرائب شدہ",
  "email_subscribed_text": "اب آپ نے بہت سارے ای میلز کو {{email}} سبسکرائب کر لیا ہے۔",
  "email_unsubscribed_text": "اب آپ نے Plentiful Emails سے {{email}} ختم کر دیا ہے۔",
  "here_to_subscribe": "Plentiful Emails کو سبسکرائب کرنے کے لیے یہاں کلک کریں۔",
  "here_to_unsubscribe": "Plentiful Emails سے ان سبسکرائب کرنے کے لیے یہاں کلک کریں۔",
  "unsubscribe": "ان سبسکرائب کریں۔",
  "subscribe": "سبسکرائب",
  "open_profile_text": "اپنے پروفائل پر جانے کے لیے یہاں کلک کریں۔",
  "sign_in_text": "سائن ان کرنے کے لیے یہاں کلک کریں۔",
  "phone_assigned": "یہ فون نمبر پہلے ہی استعمال میں ہے۔ دوسرا فون نمبر درج کریں یا واپس جائیں اور اس کے بجائے اس فون نمبر کے ساتھ سائن ان کریں۔",
  "email_subscribe": "ای میل اپ ڈیٹس",
  "email_subscribe_helper": "جن پینٹریوں کا آپ دورہ کرتے ہیں اور Plentiful کی ای میلز",
  "message_preferences": "پیغام کی ترجیحات",
  "message_preferences_description": "آپ ملاقات کی یاد دہانیاں اور اپ ڈیٹس کیسے حاصل کرنا چاہیں گے؟",
  "message_method_option_0": "ای میل اور ایپ نوٹیفیکیشنز",
  "message_method_option_1": "SMS کو ترجیح",
  "message_method_helper_add_phone": "SMS پیغامات حاصل کرنے کے لیے اپنا فون نمبر شامل کریں",
  "message_method_helper_sms_opt_in": "SMS دوبارہ حاصل کرنے کے لیے PANTRY (726-879) پر 'START' بھیجیں",
  "message_method_helper_add_email": "ای میل پیغامات حاصل کرنے کے لیے اپنا ای میل شامل کریں",
  "message_method_helper_email_unsub": "آپ نے ای میلز سے ان سبسکرائب کر دیا ہے۔ ای میلز حاصل کرنے کے لیے اپنی ترجیحات اپ ڈیٹ کریں۔",
  "message_method_helper_add_push": "پش نوٹیفیکیشنز حاصل کرنے کے لیے موبائل ایپ ڈاؤن لوڈ کریں",
  "message_method_helper_enable_push": "پش نوٹیفیکیشنز حاصل کرنے کے لیے اپنے آلے کی ترتیبات میں نوٹیفیکیشنز فعال کریں",
  "password_error": "غلط پاس ورڈ. دوبارہ کوشش کریں، اپنا پاس ورڈ دوبارہ ترتیب دیں، یا کسی اور طریقے سے سائن ان کریں۔",
  "action_required": "کارروائی کی ضرورت",
  "otp_error": "کوڈ کی تصدیق نہیں ہو سکی",
  "show_more": "مزید دکھائیں",
  "pre_registration": "اندراج",
  "show_less": "کم دکھائیں۔",
  "reschedule": "ری شیڈول کریں۔",
  "view_pantry": "پینٹری کی تفصیلات دیکھیں",
  "next_service_on": "اگلی سروس آن",
  "add_birthday": "اپنے Plenti-Pass کو غیر مقفل کرنے کے لیے اپنی سالگرہ شامل کریں۔",
  "birthday_required": "یہ پاس پینٹریز میں فوری اور آسان چیک ان کے لیے استعمال کیا جا سکتا ہے۔",
  "missed_reservation_on": "آپ نے اپنی ریزرویشن سے محروم کر دیا۔",
  "delete_account": "کھاتہ مٹا دو",
  "delete_explain": "کیا آپ واقعی اپنا اکاؤنٹ حذف کرنا چاہتے ہیں؟ اس سے پینٹری کے تمام آنے والے دورے منسوخ ہو جائیں گے اور آپ کا اکاؤنٹ حذف ہو جائے گا۔ Plentiful استعمال کرنے کے لیے آپ کو دوبارہ رجسٹر کرنے کی ضرورت ہوگی۔",
  "yes_delete": "ہاں، حذف کریں۔",
  "no_cancel": "نہیں، منسوخ کریں۔",
  "select_visit_reschedule": "وہ دورہ منتخب کریں جسے آپ دوبارہ شیڈول کرنا چاہتے ہیں۔",
  "select_visit_cancel": "وہ دورہ منتخب کریں جسے آپ منسوخ کرنا چاہتے ہیں۔",
  "search_pantries": "پینٹریز تلاش کریں۔",
  "please_sign_in_or_up": "جاری رکھنے کے لیے آپ کو ایک Plentiful اکاؤنٹ کی ضرورت ہوگی۔ Plentiful استعمال کرنے کے لئے مکمل طور پر مفت ہے۔",
  "sign_in_or_up": "جاری رکھنے کے لیے لاگ ان یا سائن اپ کریں۔",
  "country_of_birth_option_AF": "افغانستان",
  "country_of_birth_option_AX": "آلینڈ جزائر",
  "country_of_birth_option_AL": "البانیہ",
  "country_of_birth_option_DZ": "الجزائر",
  "country_of_birth_option_AS": "امریکی ساموا",
  "country_of_birth_option_AD": "اندورا",
  "country_of_birth_option_AO": "انگولا",
  "country_of_birth_option_AI": "انگویلا",
  "country_of_birth_option_AQ": "انٹارکٹیکا",
  "country_of_birth_option_AG": "انٹیگوا اور باربوڈا",
  "country_of_birth_option_AR": "ارجنٹائن",
  "country_of_birth_option_AM": "آرمینیا",
  "country_of_birth_option_AW": "اروبا",
  "country_of_birth_option_AU": "آسٹریلیا",
  "country_of_birth_option_AT": "آسٹریا",
  "country_of_birth_option_AZ": "آذربائیجان",
  "country_of_birth_option_BS": "بہاماس",
  "country_of_birth_option_BH": "بحرین",
  "country_of_birth_option_BD": "بنگلہ دیش",
  "country_of_birth_option_BB": "بارباڈوس",
  "country_of_birth_option_BY": "بیلاروس",
  "country_of_birth_option_BE": "بیلجیم",
  "country_of_birth_option_BZ": "بیلیز",
  "country_of_birth_option_BJ": "بینن",
  "country_of_birth_option_BM": "برمودا",
  "country_of_birth_option_BT": "بھوٹان",
  "country_of_birth_option_BO": "بولیویا",
  "country_of_birth_option_BA": "بوسنیا اور ہرزیگوینا",
  "country_of_birth_option_BW": "بوٹسوانا",
  "country_of_birth_option_BV": "بوویٹ جزیرہ",
  "country_of_birth_option_BR": "برازیل",
  "country_of_birth_option_IO": "برطانوی بحر ہند کا علاقہ",
  "country_of_birth_option_BN": "برونائی دارالسلام",
  "country_of_birth_option_BG": "بلغاریہ",
  "country_of_birth_option_BF": "برکینا فاسو",
  "country_of_birth_option_BI": "برونڈی",
  "country_of_birth_option_KH": "کمبوڈیا",
  "country_of_birth_option_CM": "کیمرون",
  "country_of_birth_option_CA": "کینیڈا",
  "country_of_birth_option_CV": "کیپ وردے",
  "country_of_birth_option_KY": "جزائر کیمن",
  "country_of_birth_option_CF": "مرکزی افریقی جمہوریت",
  "country_of_birth_option_TD": "چاڈ",
  "country_of_birth_option_CL": "چلی",
  "country_of_birth_option_CN": "چین",
  "country_of_birth_option_CX": "کرسمس جزیرہ",
  "country_of_birth_option_CC": "کوکوس (کیلنگ) جزائر",
  "country_of_birth_option_CO": "کولمبیا",
  "country_of_birth_option_KM": "کوموروس",
  "country_of_birth_option_CG": "کانگو",
  "country_of_birth_option_CD": "کانگو، جمہوری جمہوریہ",
  "country_of_birth_option_CK": "کوک جزائر",
  "country_of_birth_option_CR": "کوسٹا ریکا",
  "country_of_birth_option_CI": "کوٹ ڈی آئیور",
  "country_of_birth_option_HR": "کروشیا",
  "country_of_birth_option_CU": "کیوبا",
  "country_of_birth_option_CY": "قبرص",
  "country_of_birth_option_CZ": "جمہوریہ چیک",
  "country_of_birth_option_DK": "ڈنمارک",
  "country_of_birth_option_DJ": "جبوتی",
  "country_of_birth_option_DM": "ڈومینیکا",
  "country_of_birth_option_DO": "ڈومینیکن ریپبلک",
  "country_of_birth_option_EC": "ایکواڈور",
  "country_of_birth_option_EG": "مصر",
  "country_of_birth_option_SV": "ال سلواڈور",
  "country_of_birth_option_GQ": "استوائی گنی",
  "country_of_birth_option_ER": "اریٹیریا",
  "country_of_birth_option_EE": "ایسٹونیا",
  "country_of_birth_option_ET": "ایتھوپیا",
  "country_of_birth_option_FK": "جزائر فاک لینڈ (مالویناس)",
  "country_of_birth_option_FO": "جزائر فیرو",
  "country_of_birth_option_FJ": "فجی",
  "country_of_birth_option_FI": "فن لینڈ",
  "country_of_birth_option_FR": "فرانس",
  "country_of_birth_option_GF": "فرانسیسی گیانا",
  "country_of_birth_option_PF": "فرانسیسی پولینیشیا",
  "country_of_birth_option_TF": "فرانسیسی جنوبی علاقے",
  "country_of_birth_option_GA": "گبون",
  "country_of_birth_option_GM": "گیمبیا",
  "country_of_birth_option_GE": "جارجیا",
  "country_of_birth_option_DE": "جرمنی",
  "country_of_birth_option_GH": "گھانا",
  "country_of_birth_option_GI": "جبرالٹر",
  "country_of_birth_option_GR": "یونان",
  "country_of_birth_option_GL": "گرین لینڈ",
  "country_of_birth_option_GD": "گریناڈا",
  "country_of_birth_option_GP": "گواڈیلوپ",
  "country_of_birth_option_GU": "گوام",
  "country_of_birth_option_GT": "گوئٹے مالا",
  "country_of_birth_option_GG": "گرنسی",
  "country_of_birth_option_GN": "گنی",
  "country_of_birth_option_GW": "گنی بساؤ",
  "country_of_birth_option_GY": "گیانا",
  "country_of_birth_option_HT": "ہیٹی",
  "country_of_birth_option_HM": "جزائر ہرڈ اور میکڈونلڈ جزائر",
  "country_of_birth_option_VA": "ہولی سی (ویٹیکن سٹی اسٹیٹ)",
  "country_of_birth_option_HN": "ہونڈوراس",
  "country_of_birth_option_HK": "ہانگ کانگ",
  "country_of_birth_option_HU": "ہنگری",
  "country_of_birth_option_IS": "آئس لینڈ",
  "country_of_birth_option_IN": "انڈیا",
  "country_of_birth_option_ID": "انڈونیشیا",
  "country_of_birth_option_IR": "ایران، اسلامی جمہوریہ",
  "country_of_birth_option_IQ": "عراق",
  "country_of_birth_option_IE": "آئرلینڈ",
  "country_of_birth_option_IM": "آئل آف مین",
  "country_of_birth_option_IL": "اسرا ییل",
  "country_of_birth_option_IT": "اٹلی",
  "country_of_birth_option_JM": "جمیکا",
  "country_of_birth_option_JP": "جاپان",
  "country_of_birth_option_JE": "جرسی",
  "country_of_birth_option_JO": "اردن",
  "country_of_birth_option_KZ": "قازقستان",
  "country_of_birth_option_KE": "کینیا",
  "country_of_birth_option_KI": "کریباتی",
  "country_of_birth_option_KP": "کوریا، جمہوری عوامی جمہوریہ",
  "country_of_birth_option_KR": "کوریا، جمہوریہ",
  "country_of_birth_option_KW": "کویت",
  "country_of_birth_option_KG": "کرغزستان",
  "country_of_birth_option_LA": "لاؤ پیپلز ڈیموکریٹک ریپبلک",
  "country_of_birth_option_LV": "لٹویا",
  "country_of_birth_option_LB": "لبنان",
  "country_of_birth_option_LS": "لیسوتھو",
  "country_of_birth_option_LR": "لائبیریا",
  "country_of_birth_option_LY": "لیبیا عرب جماہیریہ",
  "country_of_birth_option_LI": "لیختنسٹین",
  "country_of_birth_option_LT": "لتھوانیا",
  "country_of_birth_option_LU": "لکسمبرگ",
  "country_of_birth_option_MO": "مکاؤ",
  "country_of_birth_option_MK": "مقدونیہ، سابق یوگوسلاو جمہوریہ",
  "country_of_birth_option_MG": "مڈغاسکر",
  "country_of_birth_option_MW": "ملاوی",
  "country_of_birth_option_MY": "ملائیشیا",
  "country_of_birth_option_MV": "مالدیپ",
  "country_of_birth_option_ML": "مالی",
  "country_of_birth_option_MT": "مالٹا",
  "country_of_birth_option_MH": "مارشل جزائر",
  "country_of_birth_option_MQ": "مارٹنیک",
  "country_of_birth_option_MR": "موریطانیہ",
  "country_of_birth_option_MU": "ماریشس",
  "country_of_birth_option_YT": "مایوٹ",
  "country_of_birth_option_MX": "میکسیکو",
  "country_of_birth_option_FM": "مائکرونیسیا، وفاقی ریاستوں",
  "country_of_birth_option_MD": "مالڈووا، جمہوریہ",
  "country_of_birth_option_MC": "موناکو",
  "country_of_birth_option_MN": "منگولیا",
  "country_of_birth_option_MS": "مونٹسریٹ",
  "country_of_birth_option_MA": "مراکش",
  "country_of_birth_option_MZ": "موزمبیق",
  "country_of_birth_option_MM": "میانمار",
  "country_of_birth_option_NA": "نمیبیا",
  "country_of_birth_option_NR": "نورو",
  "country_of_birth_option_NP": "نیپال",
  "country_of_birth_option_NL": "نیدرلینڈز",
  "country_of_birth_option_AN": "نیدرلینڈ اینٹیلز",
  "country_of_birth_option_NC": "نیو کیلیڈونیا",
  "country_of_birth_option_NZ": "نیوزی لینڈ",
  "country_of_birth_option_NI": "نکاراگوا",
  "country_of_birth_option_NE": "نائجر",
  "country_of_birth_option_NG": "نائیجیریا",
  "country_of_birth_option_NU": "نیو",
  "country_of_birth_option_NF": "نورفولک جزیرہ",
  "country_of_birth_option_MP": "شمالی ماریانا جزائر",
  "country_of_birth_option_NO": "ناروے",
  "country_of_birth_option_OM": "عمان",
  "country_of_birth_option_PK": "پاکستان",
  "country_of_birth_option_PW": "پلاؤ",
  "country_of_birth_option_PS": "فلسطینی علاقہ، مقبوضہ",
  "country_of_birth_option_PA": "پانامہ",
  "country_of_birth_option_PG": "پاپوا نیو گنی",
  "country_of_birth_option_PY": "پیراگوئے",
  "country_of_birth_option_PE": "پیرو",
  "country_of_birth_option_PH": "فلپائن",
  "country_of_birth_option_PN": "پٹکیرن",
  "country_of_birth_option_PL": "پولینڈ",
  "country_of_birth_option_PT": "پرتگال",
  "country_of_birth_option_PR": "پورٹو ریکو",
  "country_of_birth_option_QA": "قطر",
  "country_of_birth_option_RE": "ری یونین",
  "country_of_birth_option_RO": "رومانیہ",
  "country_of_birth_option_RU": "روسی",
  "country_of_birth_option_RW": "روانڈا",
  "country_of_birth_option_SH": "سینٹ ہیلینا",
  "country_of_birth_option_KN": "سینٹ کٹس اینڈ نیوس",
  "country_of_birth_option_LC": "سینٹ لوسیا",
  "country_of_birth_option_PM": "سینٹ پیئر اور میکیلون",
  "country_of_birth_option_VC": "سینٹ ونسنٹ اور گریناڈائنز",
  "country_of_birth_option_WS": "ساموا",
  "country_of_birth_option_SM": "سان مارینو",
  "country_of_birth_option_ST": "ساؤ ٹوم اور پرنسپے۔",
  "country_of_birth_option_SA": "سعودی عرب",
  "country_of_birth_option_SN": "سینیگال",
  "country_of_birth_option_CS": "سربیا اور مونٹی نیگرو",
  "country_of_birth_option_SC": "سیشلز",
  "country_of_birth_option_SL": "سیرا لیون",
  "country_of_birth_option_SG": "سنگاپور",
  "country_of_birth_option_SK": "سلوواکیہ",
  "country_of_birth_option_SI": "سلووینیا",
  "country_of_birth_option_SB": "جزائر سلیمان",
  "country_of_birth_option_SO": "صومالیہ",
  "country_of_birth_option_ZA": "جنوبی افریقہ",
  "country_of_birth_option_GS": "جنوبی جارجیا اور جنوبی سینڈوچ جزائر",
  "country_of_birth_option_ES": "سپین",
  "country_of_birth_option_LK": "سری لنکا",
  "country_of_birth_option_SD": "سوڈان",
  "country_of_birth_option_SR": "سورینام",
  "country_of_birth_option_SJ": "سوالبارڈ اور جان ماین",
  "country_of_birth_option_SZ": "سوازی لینڈ",
  "country_of_birth_option_SE": "سویڈن",
  "country_of_birth_option_CH": "سوئٹزرلینڈ",
  "country_of_birth_option_SY": "شامی عرب جمہوریہ",
  "country_of_birth_option_TW": "تائیوان، چین کا صوبہ",
  "country_of_birth_option_TJ": "تاجکستان",
  "country_of_birth_option_TZ": "تنزانیہ، متحدہ جمہوریہ",
  "country_of_birth_option_TH": "تھائی لینڈ",
  "country_of_birth_option_TL": "تیمور-لیستے",
  "country_of_birth_option_TG": "جانے کے لئے",
  "country_of_birth_option_TK": "ٹوکیلاؤ",
  "country_of_birth_option_TO": "ٹونگا",
  "country_of_birth_option_TT": "ٹرینیڈاڈ اور ٹوباگو",
  "country_of_birth_option_TN": "تیونس",
  "country_of_birth_option_TR": "ترکی",
  "country_of_birth_option_TM": "ترکمانستان",
  "country_of_birth_option_TC": "ترک اور کیکوس جزائر",
  "country_of_birth_option_TV": "تووالو",
  "country_of_birth_option_UG": "یوگنڈا",
  "country_of_birth_option_UA": "یوکرین",
  "country_of_birth_option_AE": "متحدہ عرب امارات",
  "country_of_birth_option_GB": "متحدہ سلطنت یونائیٹڈ کنگڈم",
  "country_of_birth_option_US": "ریاستہائے متحدہ",
  "country_of_birth_option_UM": "ریاست ہائے متحدہ امریکہ کے چھوٹے بیرونی جزائر",
  "country_of_birth_option_UY": "یوراگوئے",
  "country_of_birth_option_UZ": "ازبکستان",
  "country_of_birth_option_VU": "وانواتو",
  "country_of_birth_option_VE": "وینزویلا",
  "country_of_birth_option_VN": "ویت نام",
  "country_of_birth_option_VG": "ورجن جزائر، برطانوی",
  "country_of_birth_option_VI": "ورجن جزائر، امریکہ",
  "country_of_birth_option_WF": "والس اور فٹونا۔",
  "country_of_birth_option_EH": "مغربی صحارا",
  "country_of_birth_option_YE": "یمن",
  "country_of_birth_option_ZM": "زیمبیا",
  "country_of_birth_option_ZW": "زمبابوے",
  "gender_option_female": "عورت",
  "gender_option_male": "مرد",
  "gender_option_nonconf": "صنف نان کنفارمنگ",
  "relationship_status_option_single": "سنگل",
  "relationship_status_option_domestic_partner": "گھریلو ساتھی",
  "relationship_status_option_common_law": "عام قانون",
  "relationship_status_option_emancipated_minor": "آزاد شدہ نابالغ",
  "relationship_status_option_married": "شادی شدہ",
  "relationship_status_option_divorced": "طلاق ہو گئی۔",
  "relationship_status_option_separated": "الگ کیا",
  "relationship_status_option_widowed": "بیوہ",
  "housing_option_own": "اپنے",
  "housing_option_room_in_apartment": "اپارٹمنٹ میں کمرہ",
  "housing_option_friends_or_family": "دوست یا خاندان",
  "housing_option_regular_rent": "باقاعدہ کرایہ",
  "housing_option_subsidized_rent": "سبسڈی والا کرایہ",
  "housing_option_shelter": "پناہ گاہ",
  "housing_option_homeless": "بے گھر",
  "employment_option_full_time": "پوراوقت",
  "employment_option_part_time": "پارٹ ٹائم",
  "employment_option_unemployed": "بے روزگار",
  "education_option_no_high_school": "کوئی ہائی سکول نہیں۔",
  "education_option_high_school_diploma": "ہائی اسکول ڈپلومہ",
  "education_option_ged": "جی ای ڈی",
  "education_option_associate_or_bachelo": "ایسوسی ایٹ یا بیچلر ڈگری",
  "education_option_post_graduate": "پوسٹ گریجویٹ تعلیم",
  "ethnicity_option_two_or_more_races": "دو یا دو سے زیادہ ریس",
  "ethnicity_option_black": "سیاہ (غیر ہسپانوی)",
  "ethnicity_option_white": "سفید (غیر ہسپانوی)",
  "ethnicity_option_hispanic_or_latino": "ہسپانوی یا لاطینی",
  "ethnicity_option_asian_or_pacific": "ایشیائی یا بحر الکاہل کے جزیرے والے",
  "ethnicity_option_american_indian_or_alaskan": "امریکی ہندوستانی یا الاسکا",
  "ethnicity_option_other": "دیگر",
  "snap_benefits": "سپلیمنٹل نیوٹریشن اسسٹنس پروگرام",
  "wic_benefits": "خواتین، شیر خوار بچوں اور بچوں کے لیے ضمنی غذائیت کا پروگرام",
  "tanf_benefits": "ضرورت مند خاندانوں کے لیے عارضی امداد",
  "medicaid_benefits": "کم آمدنی والے لوگوں کے لیے پبلک ہیلتھ انشورنس",
  "ssi_benefits": "اضافی سیکورٹی انکم پروگرام",
  "free_reduced_meals": "مفت یا کم کھانے کا پروگرام",
  "tefap_form": "TEFAP تصدیق",
  "tefap_form_expired": "آپ کی TEFAP تصدیق کی میعاد ختم ہو گئی۔",
  "tefap_form_usda_title": "USDA غیر امتیازی بیان",
  "tefap_form_usda_subheader": "براہ کرم درج ذیل سے آگاہ کیا جائے۔",
  "tefap_form_usda_body": "<p>In accordance with Federal civil rights law and U.S. Department of Agriculture (USDA) civil rights regulations and policies, the USDA, its Agencies, offices, and employees, and institutions participating in or administering USDA programs are prohibited from discriminating based on race, color, national origin, religion, sex, disability, age, marital status, family/parental status, income derived from a public assistance program, political beliefs, or reprisal or retaliation for prior civil rights activity, in any program or activity conducted or funded by USDA (not all bases apply to all programs). Remedies and complaint filing deadlines vary by program or incident.</p><p>Persons with disabilities who require alternative means of communication for program information (e.g., Braille, large print, audiotape, American Sign Language, etc.) should contact the State or local Agency that administers the program or contact USDA through the Telecommunications Relay Service at 711 (voice and TTY). Additionally, program information may be made available in languages other than English.</p><p>To file a program discrimination complaint, complete the USDA Program Discrimination Complaint Form, AD-3027, found online at <a href=\"https://www.usda.gov/oascr/how-to-file-a-program-discrimination-complaint\">How to File a Program Discrimination Complaint</a> and at any USDA office or write a letter addressed to USDA and provide in the letter all of the information requested in the form. To request a copy of the complaint form, call (866) 632-9992. Submit your completed form or letter to USDA by:</p><p>(1) mail: U.S. Department of Agriculture, Office of the Assistant Secretary for Civil Rights, 1400 Independence Avenue, SW, Mail Stop 9410, Washington, D.C. 20250-9410;</p><p>(2) fax: (202) 690-7442; or</p><p>(3) email: <a href=\"mailto:program.intake@usda.gov\">program.intake@usda.gov</a>.</p><p>USDA is an equal opportunity provider, employer, and lender.</p>",
  "app_button_next": "اگلے",
  "app_button_back": "پیچھے",
  "app_button_submit": "جمع کرائیں",
  "app_button_close": "بند کریں",
  "app_button_done": "ہو گیا",
  "form_required": "درکار ہے۔ *",
  "benefits": "فائدے کے پروگرام",
  "benefits_extra": "فوائد کے پروگراموں کے بارے میں تفصیلات",
  "help_and_support": "ہم مدد کے لیے حاضر ہیں۔",
  "help_and_support_extra": "اکثر پوچھے گئے سوالات اور رابطے کی معلومات",
  "frequently_asked_questions": "اکثر پوچھے گئے سوالات",
  "contact_support": "بہت زیادہ سپورٹ سے رابطہ کریں۔",
  "optional_details": "اختیاری تفصیلات",
  "address_street_1": "گلی کا پتہ",
  "address_street_2": "اپٹ",
  "city": "شہر",
  "state": "حالت",
  "zipcode": "زپ کوڈ",
  "additional_optional_details": "اضافی تفصیلات",
  "gender": "صنف",
  "relationship_status": "رشتہ کی حیثیت",
  "ethnicity": "نسل",
  "country_of_birth": "وطن پیدائش",
  "employment": "روزگار",
  "highest_education_obtained": "تعلیم",
  "food_preferences": "کھانے کی ترجیحات",
  "housing_details": "ہاؤسنگ کی تفصیلات",
  "housing_status": "رہائش کی حیثیت",
  "special_circumstances": "خاص حالات",
  "needs_assistance": "مجھے پینٹری میں مدد کی ضرورت ہے۔",
  "dont_need_assistance": "مجھے پینٹری میں مدد کی ضرورت نہیں ہے۔",
  "aiq_validation_error_min_adult_family_members": "بالغ گھریلو اراکین کی تعداد 0 سے زیادہ ہونی چاہیے۔",
  "aiq_validation_error_max_adult_family_members": "بالغ گھریلو اراکین کی تعداد 10 سے زیادہ نہیں ہو سکتی",
  "aiq_validation_error_min_child_family_members": "چائلڈ فیملی ممبرز کی تعداد 0 سے زیادہ ہونی چاہیے۔",
  "aiq_validation_error_max_child_family_members": "چائلڈ فیملی ممبران 10 سے زیادہ نہیں ہو سکتے",
  "aiq_validation_error_min_senior_family_members": "گھر کے سینئر ارکان کی تعداد 0 سے زیادہ ہونی چاہیے۔",
  "aiq_validation_error_max_senior_family_members": "گھر کے سینئر ممبران 10 سے زیادہ نہیں ہو سکتے",
  "aiq_validation_error_required_emergency_contact": "ہنگامی رابطہ کی معلومات درکار ہے۔",
  "aiq_validation_error_required_pick_up_name": "پک اپ نمائندے کے نام کی معلومات درکار ہے۔",
  "aiq_validation_error_required_birth_date": "تاریخ پیدائش کی معلومات درکار ہے۔",
  "aiq_validation_error_regex_zip_code": "زپ کوڈ عددی ہونا چاہیے۔",
  "aiq_validation_error_required_first_name": "پہلا نام درکار ہے۔",
  "aiq_validation_error_required_last_name": "آخری نام درکار ہے۔",
  "aiq_validation_error_min_baby_supplies": "بچے کی فراہمی 0 سے زیادہ ہونی چاہیے۔",
  "aiq_validation_error_max_baby_supplies": "بچوں کا سامان 10 سے زیادہ نہیں ہو سکتا",
  "dietary_preferences_option_lactose": "لیکٹوج عدم برداشت",
  "dietary_preferences_option_gluten": "گلوٹین عدم رواداری",
  "dietary_preferences_option_kosher": "کوشر",
  "dietary_preferences_option_halal": "حلال",
  "dietary_preferences_option_dairy_free": "ڈیری فری",
  "dietary_preferences_option_vegetarian": "سبزی خور",
  "dietary_preferences_option_vegan": "ویگن",
  "dietary_preferences_option_fodmap": "FODMAP.",
  "dietary_preferences_option_nut_allergy": "ٹری نٹ اور مونگ پھلی کی الرجی۔",
  "dietary_preferences_option_fish_allergy": "مچھلی اور شیلفش کی الرجی۔",
  "dietary_preferences_option_none": "کوئی ترجیحات نہیں۔",
  "tefap_additional_info_requested": "اضافی معلومات کی درخواست کی گئی۔",
  "tefap_zipcode_correct": "کیا آپ کا زپ کوڈ درست ہے؟",
  "tefap_address_correct": "کیا آپ کا پتہ درست ہے؟",
  "tefap_participate_in_programs": "کیا آپ کے گھر کا کوئی فرد مندرجہ ذیل پروگراموں میں سے کسی میں شرکت کرتا ہے؟ ",
  "tefap_check_all_that_apply": "براہ کرم ان سب کو منتخب کریں جو لاگو ہوں۔ اگر کوئی نہیں تو، مزید اختیارات کے لیے اگلا پر ٹیپ کریں۔",
  "tefap_household_numbers_correct": "کیا آپ کے گھر کے لوگوں کی تعداد درست ہے؟",
  "tefap_household_dont_include_yourself": "براہ کرم اپنے آپ کو اس اسکرین پر شامل نہ کریں۔ TEFAP کو صرف آپ کے گھریلو سائز کی ضرورت ہے، لیکن Plentiful وہ معلومات دکھا رہا ہے جو آپ نے پہلے فراہم کی تھی۔",
  "tefap_income_at_or_below_question": "آپ کی آمدنی ہے یا اس سے کم؟",
  "tefap_for_household_size": "آپ کے گھر والوں کے لیے",
  "tefap_retake_attestation": "کیا آپ دوبارہ تصدیق کرنا چاہتے ہیں؟",
  "tefap_attestation_completed": "آپ نے کامیابی سے TEFAP تصدیقی فارم مکمل کر لیا ہے۔",
  "tefap_thank_you": "شکریہ!",
  "tefap_is_recorded": "آپ کی TEFAP تصدیق ریکارڈ کی گئی ہے۔ آپ اسے اپنے پروفائل میں دوبارہ لے سکتے ہیں۔",
  "tefap_sign_below": "آپ کا نام (اختیاری)",
  "tefap_legal_signing": "ذیل میں دستخط کر کے، میں اعلان کرتا ہوں کہ تمام ذرائع سے میری آمدنی اوپر دی گئی آمدنی سے زیادہ نہیں ہے جن کے گھرانوں کی تعداد میرے گھر والوں کے برابر ہے یا یہ کہ میرا گھرانہ اس پروگرام (پروگراموں) میں شرکت کرتا ہے جسے میں نے اس فارم پر چیک کیا ہے۔ میں سمجھتا ہوں کہ یہ ریکارڈ اس تقسیم کی جگہ پر اعتماد میں رکھے جائیں گے لیکن ان کی درخواست پر نظرثانی کے لیے نیویارک اسٹیٹ آفس آف جنرل سروسز یا ریاستہائے متحدہ کے محکمہ زراعت کو جاری کیے جا سکتے ہیں۔",
  "tefap_retake": "دوبارہ لینا",
  "program_complete_now": "اب مکمل کریں۔",
  "program_complete_later": "پینٹری میں مکمل کریں۔",
  "reservation_confirmed": "تصدیق شدہ ملاحظہ کریں۔",
  "tefap_reservation_confirmed": "آپ کے دورے کی تصدیق ہو گئی ہے!",
  "pre_registration_confirmed": "تصدیق شدہ ملاحظہ کریں۔",
  "your_upcoming_reservation": "آپ کا آنے والا دورہ",
  "your_upcoming_pre_registration": "آپ کا آنے والا دورہ",
  "tefap_attestation_needed": "یہ پینٹری TEFAP تصدیق کی بھی درخواست کر رہی ہے۔",
  "tefap_attestation_complete_now": "اسے ابھی مکمل کریں اور اپنے اگلے پینٹری کے دورے پر وقت بچائیں، یا پینٹری میں مکمل کریں۔",
  "tefap_description": "ایمرجنسی فوڈ اسسٹنس پروگرام (TEFAP) کے ذریعے، USDA آپ کی مقامی کمیونٹی کو فوڈ سپورٹ فراہم کرتا ہے، یہ آپ کو کمیونٹی ایجنسیوں جیسے سوپ کچن اور فوڈ پینٹریز کے ذریعے دستیاب کرتا ہے۔",
  "tefap_what_is_tefap": "TEFAP کے بارے میں یہاں مزید جانیں۔",
  "tefap_confirm_share_with_pantry": "براہ کرم تصدیق کریں کہ آپ اس پینٹری کے ساتھ درج ذیل معلومات کا اشتراک کرنا چاہتے ہیں۔",
  "tefap_thanks_for_sharing": "پینٹری کے ذریعہ درخواست کردہ اضافی معلومات فراہم کرنے کے لئے آپ کا شکریہ!",
  "tefap_continue_make_reservation": "وزٹ کا شیڈول جاری رکھیں",
  "tefap_pantry_is_requesting": "یہ پینٹری آپ کی درخواست کر رہی ہے۔",
  "tefap_missing_information": "نا مکمل معلومات",
  "tefap_pantry_will_ask": "اس معلومات کو ابھی شامل کرنے کے لیے 'اگلا' پر کلک کریں۔ اگر آپ اسے چھوڑ دیتے ہیں، تو پینٹری آپ کے اگلے دورے پر اسے طلب کرے گی۔",
  "tefap_submission_pending": "پینٹری میں اپنے جوابات جمع کرائے جا رہے ہیں...",
  "cancel_edit": "ترمیم منسوخ کریں۔",
  "edit": "ترمیم",
  "select": "منتخب کریں۔",
  "can_prepare_food": "کھانا تیار کر سکتے ہیں۔",
  "cannot_prepare_food": "کھانا تیار نہیں کر سکتے",
  "pantry_details_prompt_title": "{{programName}} درکار ہے",
  "pantry_details_prompt_without_visit_label": "یہ فوڈ بینک رجسٹریشن کے لیے {{programName}} استعمال کرتا ہے۔ جب آپ فوڈ بینک پہنچیں گے تو آپ کو اضافی سوالات کے جوابات دینے ہوں گے۔",
  "pantry_details_prompt_visit_label": "یہ فوڈ بینک رجسٹریشن کے لیے {{programName}} استعمال کرتا ہے۔ اپنے اگلے دورے کا وقت بچانے کے لیے آن لائن ان سوالات کے جوابات دیں۔",
  "state_program_attestation_cannot_complete": "معذرت، لیکن ہم اس وقت آپ کی تصدیق مکمل نہیں کر سکتے۔ آپ بعد میں دوبارہ کوشش کر سکتے ہیں، سپورٹ سے رابطہ کر سکتے ہیں، یا جب آپ پینٹری پہنچیں تو یہ مکمل کر سکتے ہیں۔",
  "state_program_attestation_submitted": "آپ کے {{programName}} کی تصدیق مکمل کرنے کے لیے شکریہ! آپ کے جوابات کامیابی سے پینٹری میں جمع کر دیے گئے ہیں۔ یہ {{programName}} سوالات کا اختتام ہے، اور کوئی بھی مزید پوچھ گچھ دوسرے Plentiful پروگراموں سے آتی ہے۔",
  "state_program_cancel_confirmation": "کیا آپ واقعی {{programName}} کے لیے اپنی تصدیق منسوخ کرنا چاہتے ہیں؟ جب آپ پینٹری کی زیارت کریں گے تو آپ کو پھر بھی ان سوالات کے جواب دینے کی ضرورت ہو سکتی ہے۔",
  "state_program_cancel_attestation": "تصدیق منسوخ کریں",
  "state_program_resume_attestation": "تصدیق جاری رکھیں",
  "tefap_no_submit": "نہیں، جمع کروائیں۔",
  "tefap_yes_retake": "ہاں، دوبارہ لیں۔",
  "tefap_expires": "میعاد ختم",
  "tefap_incomplete": "نامکمل، اپنے اگلے پینٹری کے دورے پر وقت بچانے کے لیے ابھی مکمل کریں۔",
  "tefap_none": "کوئی نہیں۔",
  "tefap_benefit_programs_select": "درج ذیل پروگراموں میں اپنا اندراج منتخب کریں۔",
  "tefap_pantry_requests_info": "یہ پینٹری آپ کے آنے والے دورے کے لیے اضافی معلومات کی درخواست کر رہی ہے۔",
  "tefap_eligible": "آپ اہل ہیں۔",
  "tefap_not_eligible": "آپ اہل نہیں ہیں۔",
  "tefap_receive_product": "TEFAP پروڈکٹ حاصل کرنے کے لیے",
  "tefap_eligible_program": "آپ مندرجہ ذیل پروگرام میں شرکت کریں۔",
  "tefap_eligible_programs": "آپ مندرجہ ذیل پروگراموں میں شرکت کریں۔",
  "tefap_not_eligible_program": "آپ کسی پروگرام میں شرکت نہیں کرتے",
  "tefap_household_income": "آپ کی گھریلو آمدنی",
  "tefap_info_changed": "کیا آپ کی TEFAP اہلیت کی معلومات (فائدے کے پروگراموں میں شرکت، گھریلو سائز اور/یا آمدنی) حال ہی میں تبدیل ہوئی ہے؟",
  "tefap_still_get_food": "آپ اب بھی پینٹری سے غیر TEFAP کھانا حاصل کر سکتے ہیں۔",
  "tefap_form_checking_here": "یہاں چیک کر کے، آپ تصدیق کرتے ہیں کہ درج ذیل سچ ہے:",
  "tefap_form_checking_1": "1. اوپر فراہم کردہ وصول کنندہ کا نام، پتہ اور گھریلو سائز درست ہے۔",
  "tefap_form_checking_2_CO": "2. وصول کنندہ کولوراڈو کے اندر رہتا ہے (رہائش کی کم از کم لمبائی کی ضرورت نہیں ہے)۔",
  "tefap_form_checking_2_NY": "2. وصول کنندہ ریاست نیویارک میں رہتا ہے (رہائش کی کم از کم لمبائی کی ضرورت نہیں ہے)۔",
  "tefap_form_checking_3": "3. وصول کنندہ اوپر TEFAP اہلیت کے رہنما خطوط کے آپشن 1 اور/یا آپشن 2 کو پورا کرتا ہے۔",
  "tefap_form_checking_4": "4. یہ کھانا صرف وصول کنندہ کے گھر کے استعمال کے لیے ہے، اور اسے فروخت، تجارت یا بارٹرڈ نہیں کیا جائے گا۔",
  "tefap_form_checking_5_1": "5. وصول کنندہ اپنے شہری حقوق سے واقف ہے جیسا کہ میں بیان کیا گیا ہے۔",
  "tefap_form_checking_5_2": "USDA غیر امتیازی بیان۔",
  "tefap_out_of_state": "آپ ایک مختلف حالت میں رہتے ہیں۔",
  "and": "اور",
  "or": "یا",
  "exceeds": "نیچے نہیں ہے",
  "not_exceeds": "سے زیادہ نہیں ہے",
  "people": "لوگ",
  "person": "شخص",
  "because": "کیونکہ",
  "custom_field_first_name": "پہلا نام",
  "custom_field_last_name": "آخری نام",
  "custom_field_contact_info": "رابطہ کی معلومات",
  "custom_field_birth_date": "سالگرہ",
  "custom_field_zip_code": "زپ کوڈ",
  "custom_field_household_size": "ہوشولڈ سائز",
  "custom_field_food_pickup": "پک اپ نمائندہ",
  "custom_field_emergency_contact": "ہنگامی رابطے",
  "custom_field_address": "پتہ",
  "custom_field_needs_assistance": "خصوصی حالات (مدد کی ضرورت ہے)",
  "custom_field_benefits_programs": "فوائد کے پروگرام",
  "custom_field_tefap_income_eligibility": "TEFAP آمدنی کی اہلیت",
  "custom_field_relationship_status": "رشتہ کی حیثیت",
  "custom_field_ethnicity": "نسل",
  "custom_field_education": "اعلیٰ ترین تعلیم حاصل کی۔",
  "custom_field_dietary_preferences": "غذائی ترجیحات",
  "custom_field_gender": "صنف",
  "custom_field_country_of_birth": "وطن پیدائش",
  "custom_field_employment": "روزگار",
  "custom_field_food_preparation": "کھانا تیار کر سکتے ہیں۔",
  "custom_field_housing": "رہائش کی حیثیت",
  "search": "تلاش کریں (پینٹری کا نام، زپ، شہر، ریاست)",
  "all": "تمام",
  "pantry_filter_program_type": "پروگرام کی قسم",
  "pantry_filter_program_type_non-food": "نان فوڈ",
  "pantry_filter_program_type_foodpantry": "فوڈ پینٹری (مفت گروسری)",
  "pantry_filter_program_type_soupkitchen": "سوپ کچن (مفت گرم کھانا)",
  "pantry_filter_status": "حالت",
  "pantry_filter_status_all": "تمام",
  "pantry_filter_status_opennow": "اب کھولیں۔",
  "pantry_filter_status_opentoday": "آج کھولیں۔",
  "pantry_filter_status_openthisweek": "اس ہفتے کھولیں۔",
  "pantry_filter_status_other": "دیگر",
  "pantry_filter_pantry_type": "پینٹری کی قسم",
  "pantry_filter_pantry_type_plentifulpantry": "بھر پور پینٹری",
  "pantry_filter_pantry_type_verifiedpartnerpantry": "تصدیق شدہ پارٹنر پینٹری",
  "pantry_filter_pantry_type_unverifiedpartnerpantry": "غیر تصدیق شدہ پارٹنر پینٹری",
  "search_no_results_found": "کوئی نتائج نہیں ملے",
  "search_no_pantries_match": "کوئی پینٹری \"{query}\" سے مطابقت نہیں رکھتی",
  "search_try_searching_by": "تلاش کرنے کی کوشش کریں:",
  "search_suggestion_city": "شہر کا نام (مثلاً، \"بروکلین\")",
  "search_suggestion_city_accessibility": "شہر کا نام، مثال کے طور پر، بروکلین",
  "search_suggestion_zipcode": "زپ کوڈ (مثلاً، \"10001\")",
  "search_suggestion_zipcode_accessibility": "زپ کوڈ، مثال کے طور پر، 10001",
  "search_suggestion_pantry_name": "پینٹری کا نام",
  "search_suggestion_street_address": "گلی کا پتہ",
  "search_accessibility_no_results": "{query} کے لیے کوئی نتائج نہیں ملے۔ شہر کے نام، زپ کوڈ، پینٹری کے نام یا گلی کے پتے سے تلاش کرنے کی کوشش کریں۔",
  "search_accessibility_no_results_generic": "کوئی نتائج نہیں ملے۔ شہر کے نام، زپ کوڈ، پینٹری کے نام یا گلی کے پتے سے تلاش کرنے کی کوشش کریں۔",
  "search_error_unable_to_display": "تلاش کے نتائج دکھانے سے قاصر",
  "search_error_occurred": "آپ کے تلاش کے نتائج دکھانے کے دوران ایک خرابی پیش آئی۔ براہ کرم دوبارہ تلاش کریں۔",
  "accessibility_phone": "فون: {phone}",
  "accessibility_email": "ای میل: {email}",
  "accessibility_website": "ویب سائٹ: {website}",
  "pantry_filter_service_type": "سروس کی قسم",
  "pantry_filter_service_type_line": "لائن پر مبنی",
  "pantry_filter_service_type_pre-registration": "پری رجسٹریشن",
  "pantry_filter_service_type_qr-code": "کیو آر کوڈ چیک ان",
  "pantry_filter_service_type_reservation": "بکنگ",
  "program_type_benefit_enrollment": "بینیفٹ انرولمنٹ",
  "program_type_emergency_services": "ہنگامی خدمات",
  "program_type_non_plentiful_pantry": "غیر بھر پور پینٹری",
  "program_type_other_services": "دیگر خدمات",
  "program_type_plentiful_pantry": "بھر پور پینٹری",
  "program_type_shelter": "پناہ گاہ",
  "program_type_soup_kitchen": "سوپ کچن",
  "service_restriction_none": "کوئی پابندی نہیں",
  "service_restriction_seniors": "صرف سینئرز",
  "service_restriction_families_with_children": "صرف بچوں والے خاندان",
  "service_restriction_new_clients": "صرف نئے کلائنٹس",
  "service_restriction_existing_clients": "صرف موجودہ کلائنٹس",
  "filter_by_category": "زمرہ کے لحاظ سے فلٹر کریں۔",
  "opted_out": "ایسا لگتا ہے کہ آپ کے فون نمبر نے SMS سے آپٹ آؤٹ کیا ہے لہذا ہم آپ کو آپ کا لاگ ان کوڈ نہیں بھیج سکتے ہیں۔ براہ کرم START کو 726879 پر ٹیکسٹ کرکے دوبارہ آپٹ ان کریں اور پھر دوبارہ کوشش کریں۔",
  "miles_away_singular": "%s میل دور",
  "miles_away_plural": "%s میل دور",
  "today": "آج",
  "address_autocomplete_placeholder": "تجاویز دیکھنے کے لیے ٹائپ کرنا شروع کریں۔",
  "push_notification_permissions_denied": "پش اطلاعات کے لیے اجازت نہیں دی گئی۔ براہ کرم اپنے سسٹم کی ترتیبات کھولیں اور پش اطلاعات کو فعال کریں۔",
  "push_notification_setup_error": "پش اطلاعات کو ترتیب دینے میں ایک خرابی تھی۔",
  "push_notification_alternate_notifications": "آپ کو اب بھی SMS یا ای میل کے ذریعے اطلاعات موصول ہوں گی۔",
  "loading_message": "اپنے قریب کھانے کی پینٹری تلاش کرنا",
  "location_services_no_access": "ایسا لگتا ہے کہ Plentiful کو آپ کے آلے کے مقام تک رسائی حاصل نہیں ہے۔ براہ کرم اپنے براؤزر یا ڈیوائس کی ترتیبات میں Plentiful کے لیے لوکیشن سروسز کو فعال کریں",
  "error_screen_header": "افوہ! کچھ غلط ہو گیا۔",
  "error_screen_message": "ہم ایک غیر متوقع مسئلہ میں بھاگ گئے۔ آپ ایپ کو دوبارہ شروع کرنے کی کوشش کر سکتے ہیں یا سپورٹ سے رابطہ کر سکتے ہیں۔",
  "restart_app": "ایپ کو دوبارہ شروع کریں۔",
  "email_support": "ای میل سپورٹ",
  "map_zoom_to_see_all": "تمام مقامات دیکھنے کے لیے زوم کریں",
  "program_eligible": "آپ {{program}} کے اہل ہیں۔",
  "program_ineligible": "آپ {{program}} کے لیے نااہل ہیں: {{reason}}",
  "program_not_applicable": "آپ نے {{program}} مکمل کر لیا ہے۔",
  "program_completed": "آپ نے تمام {{program}} سوالات مکمل کر لیے ہیں۔",
  "program_unknown_eligibility": "فارم مکمل کرنے کا شکریہ۔ آپ کے پہنچنے پر فراہم کنندہ آپ کی اہلیت کا تعین کرے گا۔"
}
